import React from 'react';
import { Crown, Store, Zap, Star, Sparkles } from 'lucide-react';
import { PricingPlanType } from '../../types/pricingPlans';
import { getPlanColor, getPlanIcon } from '../../utils/pricingPlanUtils';

interface PlanBadgeProps {
  planId: PricingPlanType;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showText?: boolean;
}

const PlanBadge: React.FC<PlanBadgeProps> = ({ planId, name, size = 'md', className = '', showText = true }) => {
  const renderIcon = (planId: PricingPlanType) => {
    const iconName = getPlanIcon(planId);
    switch (iconName) {
      case 'zap':
        return <Zap className="w-4 h-4" />;
      case 'star':
        return <Star className="w-4 h-4" />;
      case 'store':
        return <Store className="w-4 h-4" />;
      case 'crown':
        return <Crown className="w-4 h-4" />;
      case 'sparkles':
        return <Sparkles className="w-4 h-4" />;
      default:
        return <Zap className="w-4 h-4" />;
    }
  };

  const getSizeClasses = (size: 'sm' | 'md' | 'lg') => {
    switch (size) {
      case 'sm':
        return 'px-2 py-1 text-xs';
      case 'md':
        return 'px-3 py-1.5 text-sm';
      case 'lg':
        return 'px-4 py-2 text-base';
      default:
        return 'px-3 py-1.5 text-sm';
    }
  };

  return (
    <div className={`inline-flex items-center rounded-full font-medium border transition-all duration-200 ${getPlanColor(planId)} ${getSizeClasses(size)} ${className}`}>
      {renderIcon(planId)}
      {showText && <span className="ml-2">{name}</span>}
    </div>
  );
};

export default PlanBadge;
